// extracted by mini-css-extract-plugin
export var modal = "_e2-0";